// import queries from "./queries/index";
// import { API, AUTH_CONTEXT } from "./api";
import { API, AUTH_CONTEXT } from "./api";
import { loadQuery } from "./utils";

export default async (endpoint, payload) => {
  let context = {};

  context.headers = {
    authorization: AUTH_CONTEXT(),
  };

  const PAYLOAD = {
    query: await loadQuery(endpoint),
    variables: payload,
    context,
  };

  return API.BURSE_API.query(PAYLOAD).then((result) => result.data[endpoint]);
};
